import React, { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { useAuth0 } from "@auth0/auth0-react";
import { BASEURL } from "components/Utils/Constants";

import Button from "components/Elements/Button";

const LoginForm = (props) => {
  const { handleSubmit, submitting, error, passLoginEmail } = props;

  const { loginWithRedirect } = useAuth0();

  const [showJWTform, setShowJWTform] = useState(true);
  const [loginEmail, setLoginEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorSSO, setErrorSSO] = useState("");
  const [showRedirectSSOmessage, setShowRedirectSSOmessage] = useState(false);

  const handleSSOform = (event) => {
    event.preventDefault();

    if (loginEmail !== "") {
      setLoading(true);
      setErrorSSO("");
      passLoginEmail(loginEmail);

      fetch(`${BASEURL}/auth/method`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: loginEmail,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.connection_name) {
            setShowRedirectSSOmessage(true);
            setTimeout(() => {
              loginWithRedirect({
                connection: res.connection_name,
                responseType: "id_token",
                redirectUri: `${window.location.origin}/sso`,
              });
            }, 2000);
          }

          if (res.type === "not_found") {
            setErrorSSO("Email not found.");
          }

          if (res.type === "password") {
            setShowJWTform(false);
          }
        });
    }
  };

  const renderRedirectMessage = () => (
    <div className="login-form-container">
      <div className="login-sso-message text-center">
        <p className="login-sso-message--text">Redirecting...</p>
      </div>
    </div>
  );

  const renderJWTform = () => (
    <div className="login-form-container">
      <div className="text-center">
        <form className="login-form" autoComplete="off">
          {errorSSO !== "" ? (
            <div className="alert alert-danger">{errorSSO}</div>
          ) : null}
          <div className="form-group">
            <input
              name="email"
              type="email"
              className="form-control form-control-lg"
              placeholder="email"
              onChange={(e) => setLoginEmail(e.currentTarget.value)}
              autoFocus
            />
          </div>

          <div className="form-group">
            <Button
              color="primary"
              className="mt-3 btn btn-lg btn-submit text-uppercase"
              onClick={(event) => handleSSOform(event)}
              disabled={loading}
              type="submit"
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </div>
  );

  const renderSSOform = () => (
    <div className="login-form-container">
      <form onSubmit={handleSubmit} className="login-form" autoComplete="off">
        {error ? <div className="alert alert-danger">{error}</div> : null}

        <div className="pt-3 form-group">
          <Field
            name="password"
            type="password"
            className="form-control form-control-lg"
            placeholder="password"
            component="input"
            autoFocus
          />
        </div>
        <div className="text-right">
          <a href="/forgot-password" className="login-form-link">
            forgot password?
          </a>
        </div>

        <div className="form-group">
          <Button
            color="primary"
            className="mt-3 btn btn-lg btn-submit text-uppercase"
            disabled={submitting}
            type="submit"
          >
            Submit
          </Button>
        </div>
        <div className="form-group">
          <span className="login-form-back login-form-back--arrow">←</span>
          <button
            className="login-form-back"
            onClick={() => setShowJWTform(true)}
          >
            back{" "}
          </button>
        </div>
      </form>
    </div>
  );

  if (showRedirectSSOmessage) {
    return renderRedirectMessage();
  } else if (showJWTform) {
    return renderJWTform();
  } else if (!showJWTform) {
    return renderSSOform();
  } else {
    return null;
  }
};

export default reduxForm({
  form: "login",
  enableReinitialize: true,
})(LoginForm);
